import styles from "./Lessons.module.css";

import IconAndName from "../../components/IconAndName/IconAndName";

import { FaUserPlus, FaUpload } from "react-icons/fa";
import { useState } from "react";

import { useDispatch } from "react-redux";
import { openModal } from "../../redux/slices/modalSlice";
import { IoAddCircleOutline } from "react-icons/io5";
import CopyRight from "../../components/CopyRight/CopyRight";
import AllScheduledMovements from "../../sections/AllScheduledMovements/AllScheduledMovements";
import ProgramLevelMovements from "../../sections/ProgramLevelMovements/ProgramLevelMovements";
import FeeComponentSection from "../../sections/FeeComponentSection/FeeComponentSection";
import Discount from "../../sections/Discount/Discount";
import TaxRate from "../../sections/TaxRate/TaxRate";
import LeavePolicy from "../../sections/LeavePolicy/LeavePolicy";
import HolidayCalendar from "../../sections/HolidayCalendar/HolidayCalendar";
import WeekendConfiguration from "../../sections/WeekendConfiguration/WeekendConfiguration";
import LessonsSection from "../../sections/LessonsSection/LessonsSection";
import WeeklyLessonPlans from "../../sections/WeeklyLessonPlans/WeeklyLessonPlans";
import Assignments from "../../sections/Assignments/Assignments";
import Submissions from "../../sections/Submissions/Submissions";

const Lessons = () => {
  // default or make it dynamic later

  const handleFeeComponent = () => {
    dispatch(openModal("createFeeComponent"));
  };

  const handleAddLessons = () => {
    dispatch(openModal("hodidayCalendar"));
  };

  const dispatch = useDispatch();

  const [activeTab, setActiveTab] = useState("Lessons");

  const tab = [
    {
      label: "Lessons",
      content: <LessonsSection />,
    },
    {
      label: "Weekly Lesson Plans",
      content: <WeeklyLessonPlans />,
    },
    {
      label: "Assignments",
      content: <Assignments />,
    },
    {
      label: "Submissions",
      content: <Submissions />,
    },
  ];

  return (
    <>
      <div className={styles.background}>
        <div className={styles.StudentSection}>
          <div className={styles.maincontainer}>
            <div className={styles.container}>
              {/* <TabSwitch tabs={tab} /> */}
              {tab.map((item, index) => {
                return (
                  <div
                    key={index}
                    className={`${styles.tabOptions} ${
                      activeTab === item.label && styles.ActivetabOption
                    }`}
                    onClick={() => setActiveTab(item.label)}
                  >
                    {item.label}
                  </div>
                );
              })}
            </div>
            {activeTab === "Lessons" && (
              <div className={styles.buttonRow}>
                <div>
                  <IconAndName
                    icon={<IoAddCircleOutline />}
                    title="Bulk Upload"
                    bgColor="Primary_Color"
                    onClick={handleFeeComponent}
                  />
                </div>
                <div>
                  <IconAndName
                    icon={<IoAddCircleOutline />}
                    title="Add Lessons"
                    bgColor="Primary_Color"
                    onClick={handleAddLessons}
                  />
                </div>
              </div>
            )}
            
          </div>
          {tab.map((item) =>
            activeTab === item.label ? <>{item.content}</> : null
          )}
        </div>
      </div>
      <div>{<CopyRight />}</div>
    </>
  );
};

export default Lessons;
